import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Outlet } from 'react-router';

import { Stub } from 'components/pages';

export type ProtectedRouteProps = {
  isAllowed: boolean;
  children?: ReactNode;
};

import './ProtectedRoute.scss';

const ProtectedRoute: FC<ProtectedRouteProps> = ({ isAllowed, children }) => {
  const [timeoutState, setTimeoutState] = useState<boolean>(false);

  useEffect(() => {
    if (!isAllowed) {
      setTimeout(() => setTimeoutState(true), 5000);
    } else {
      setTimeoutState(false);
    }
  }, [isAllowed]);

  if (!isAllowed) {
    return timeoutState ? <Stub type={'denied'} /> : <></>;
  }

  return <>{children || <Outlet />}</>;
};

export default ProtectedRoute;
